(function (Drupal, $) {
  Drupal.behaviors.teamCard = {
    attach: function (context) {
      $(".our-team .our-team__item")
        .once()
        .each(function () {
          var $this = $(this);
          $this.on("click", function (e) {
            $this.children(".our-team__item-bio, .bio-bg").fadeIn(300);
          });

          $(".bio-close, .bio-bg").on("click", function (e) {
            e.stopPropagation();
            $(this).closest(".our-team__item-bio").fadeOut(300);
            $(this).siblings(".our-team__item-bio").fadeOut(300);
            $(".bio-bg").fadeOut(300);
          });
        });
    },
  };
})(Drupal, jQuery);
